import React from 'react';

// IMPORTANT: Always import this component — never define form field helpers inside
// a component function, as it causes React to remount inputs and lose focus on every keystroke.

export const FF = ({ label, name, form, setForm, type = 'text', children, rows, placeholder, required }) => (
  <div>
    <label className="block text-xs font-medium mb-1" style={{ color: '#475569' }}>
      {label}{required && <span style={{ color: '#ef4444' }}> *</span>}
    </label>
    {children || (
      rows ? (
        <textarea
          rows={rows}
          value={form[name] || ''}
          onChange={e => setForm({ ...form, [name]: e.target.value })}
          placeholder={placeholder}
          className="input-dark"
          style={{ resize: 'vertical', minHeight: rows * 24 }}
        />
      ) : (
        <input
          type={type}
          required={required}
          value={form[name] || ''}
          onChange={e => setForm({ ...form, [name]: e.target.value })}
          placeholder={placeholder}
          className="input-dark"
        />
      )
    )}
  </div>
);

export const FS = ({ label, name, form, setForm, options, placeholder, required }) => (
  <div>
    <label className="block text-xs font-medium mb-1" style={{ color: '#475569' }}>
      {label}{required && <span style={{ color: '#ef4444' }}> *</span>}
    </label>
    <select
      required={required}
      value={form[name] || ''}
      onChange={e => setForm({ ...form, [name]: e.target.value })}
      className="input-dark"
    >
      <option value="">{placeholder || 'Select...'}</option>
      {options.map(o => (
        <option key={o.val ?? o} value={o.val ?? o}>{o.label ?? String(o).replace(/_/g, ' ')}</option>
      ))}
    </select>
  </div>
);

export const ErrMsg = ({ msg }) => msg ? (
  <div className="px-3 py-2 rounded-xl text-sm" style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', color: '#f87171' }}>
    {msg}
  </div>
) : null;
